import "../styles/Recipe.css";
import "../styles/Buttons.css";
import { useNavigate } from "react-router-dom";

import React from "react";

function TopNavbarBack(props) {
  const {
    title,
    rbuttonIcon,
    lbuttonIcon,
    rbackground,
    lbackground,
    rfunction,
    lfunction,
  } = props;
  const navigate = useNavigate();
	const goBack = () => {
		navigate(-1);
	}

  return (
    <div className="spc-between topnav-container">
      <a onClick={goBack} className={rbackground}>
        {rbuttonIcon.map((icon, index) => (
          <div key={index}>
            <span className={icon}></span>
          </div>
        ))}
      </a>

      <p className="heading-1">{title}</p>

      <a onClick={lfunction} className={lbackground}>
        {lbuttonIcon.map((icon, index) => (
          <div key={index}>
            <span className={icon}></span>
          </div>
        ))}
      </a>
    </div>
  );
}

export default TopNavbarBack;